import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const CheckSquare = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.color || "currentColor"}
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M16 4.6665C17.7795 4.6665 19.2335 6.06114 19.3284 7.81696L19.3334 7.99984V15.9998C19.3334 17.7793 17.9387 19.2333 16.1829 19.3282L16 19.3332H8.00002C6.22053 19.3332 4.76657 17.9385 4.67162 16.1827L4.66669 15.9998V7.99984C4.66669 6.22034 6.06132 4.76639 7.81714 4.67144L8.00002 4.6665H16ZM16 5.99984H8.00002C6.94575 5.99984 6.08186 6.8158 6.00551 7.85059L6.00002 7.99984V15.9998C6.00002 17.0541 6.81598 17.918 7.85077 17.9944L8.00002 17.9998H16C17.0543 17.9998 17.9182 17.1839 17.9945 16.1491L18 15.9998V7.99984C18 6.94556 17.1841 6.08168 16.1493 6.00532L16 5.99984ZM14.9274 10.3025C15.0793 10.0052 14.9876 9.63478 14.7032 9.44514C14.3968 9.2409 13.9829 9.32368 13.7787 9.63004L11.4814 13.0745L10.0365 12.1118L9.96931 12.0724C9.67207 11.9205 9.30163 12.0122 9.11199 12.2967C8.90775 12.6031 8.99053 13.017 9.29689 13.2212L11.2969 14.5545L11.3641 14.5939C11.6613 14.7458 12.0317 14.6541 12.2214 14.3696L14.8881 10.3696L14.9274 10.3025Z"
            : "M7.33329 4.6665H16.6666C18.1393 4.6665 19.3333 5.8605 19.3333 7.33317V16.6665C19.3333 18.1392 18.1393 19.3332 16.6666 19.3332H7.33329C5.86063 19.3332 4.66663 18.1392 4.66663 16.6665V7.33317C4.66663 5.8605 5.86063 4.6665 7.33329 4.6665ZM11.4326 14.9078L15.8393 9.76717C16.0793 9.48784 16.0466 9.0665 15.7666 8.82717C15.488 8.58784 15.0666 8.6205 14.8266 8.89917L11.2333 13.0918L9.06663 11.4665C8.77129 11.2452 8.35396 11.3065 8.13329 11.5998C7.91263 11.8945 7.97196 12.3125 8.26663 12.5332L11.4326 14.9078Z"
        }
      />
    </svg>
  );
};
